import * as React from 'react';
import styled from 'styled-components';
import FooterLegalDocuments from './FooterLegalDocuments';
import vettingLogoPng from '../../../images/vetting-logo.png';
import './Footer.less';

const Footer = (props: Props) => (
	<section className={props.showPoweredBy ? 'globalFooter PoweredBy' : 'globalFooter'}>
		{props.showPoweredBy && (
			<VettingLabel>
				<label>Powered by </label>
				<LogoWrapper>
					<VettingLogo src={vettingLogoPng} alt="logo" style={{ height: '17px' }} />
				</LogoWrapper>
			</VettingLabel>
		)}
		<p className="globalFooterText">&copy; Copyright {getCurrentYear()} VETTING.com</p>
		<FooterLegalDocuments />
	</section>
);

const getCurrentYear = () => new Date().getFullYear();

interface Props {
	showPoweredBy?: boolean;
}

Footer.defaultProps = {
	showPoweredBy: false
};

export default Footer;

const VettingLabel = styled.div.attrs({
	className: 'vettingLabel'
})`
	&&&& {
		font-size: 14px;
		font-weight: 400;
		height: 68px;
	}
`;

const LogoWrapper = styled.span.attrs({
	className: 'logoWrapper'
})`
	&& {
		padding-left: 5px;
		margin: unset !important;
	}
`;

const VettingLogo = styled.img.attrs({
	className: 'vettingLogoPng'
})`
	&& {
		margin-bottom: -4px;
	}
`;
